export default __webpack_public_path__ + "static/media/fireControl-show1.cafe1f4c.png";